// src/components/User/Gallery.js
import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

export default function Gallery({ images }) {
    const [openIndex, setOpenIndex] = useState(-1);

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <>
            {/* Thumbnail grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                {images.map((src, i) => (
                    <img
                        key={i}
                        src={src}
                        className="cursor-pointer w-full h-32 object-cover rounded"
                        onClick={() => setOpenIndex(i)}
                    />
                ))}
            </div>

            {/* Lightbox */}
            <Lightbox
                open={openIndex >= 0}
                close={() => setOpenIndex(-1)}
                slides={images.map(src => ({ src }))}
                plugins={[Thumbnails]}
            />
        </>
    );
}
